import "./ErrorMessage.css";

type ErrorMessageProps = {
  message: string;
  onRetry?: () => void;
};

export function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  return (
    <div class="error-message" role="alert">
      <div class="error-message__icon" aria-hidden="true">
        ⚠️
      </div>
      <div class="error-message__content">
        <p class="error-message__title">Terjadi kesalahan</p>
        <p class="error-message__text">{message}</p>
        {onRetry && (
          <button
            class="error-message__button"
            type="button"
            onClick={onRetry}
          >
            Coba lagi
          </button>
        )}
      </div>
    </div>
  );
}
